import { environment } from '../../environments/environment';

export const prefixUrl = environment.apiBaseUrl;

export const RestEndpoint = {
    authenticateUser: prefixUrl + '/v1/authentication/authenticateUser',
    publicRsa: prefixUrl + '/v1/authentication/getPublicKeyRsa',
    getAllUsers: prefixUrl + '/v1/authentication/getAllUsers',
    changeBu: prefixUrl + '/v1/authentication/changeBu',
    sendContactEmail: prefixUrl + '/v1/authentication/sendKairosContactEmail',
    updateFavorite: prefixUrl + '/v1/products-favorites/updateFavorite',
    countFavorites: prefixUrl + '/v1/products-favorites/countFavorites',
    createFavorite: prefixUrl + '/v1/products-favorites/createFavorite',
    getStore: prefixUrl + '/v1/stores/getStore',
    createWatch:  prefixUrl + '/v1/products-favorites/createWatch',
    createUser:  prefixUrl + '/v1/authentication/createuser',
    translatableTexts: prefixUrl + '/v1/translate/getTranslatableTexts',
    destroySession: prefixUrl + '/v1/authentication/destroySession',
    lostpassword: prefixUrl + '/v1/authentication/lostpassword',
    changelostpassword: prefixUrl + '/v1/authentication/changelostpassword',
    isAuthenticated: prefixUrl + '/v1/authentication/isAuthenticated',
    verifyDocument: prefixUrl + '/v1/authentication/validateDocument',
    changeNewsLetter: prefixUrl + '/v1/authentication/changeNewsLetter',
    getAllProducts: prefixUrl + '/v1/products/getAllProducts',
    searchProducts: prefixUrl + '/v1/products/searchProducts',
    balance: prefixUrl + '/v1/financial/plataformbalance',
    getAllOrders: prefixUrl + '/v1/orders/user',
    changeOrderStatus: prefixUrl + '/v1/orders/updateInformation/',
    createProduct: prefixUrl + '/v1/products/createProduct',
    updateProducts: prefixUrl + '/v1/products/updateProducts',
    getProduct: prefixUrl + '/v1/products/getProduct',
    deleteProduct: prefixUrl + '/v1/products/product/',
    getAllCategories: prefixUrl + '/v1/categories/getAllCategories',
    createCategory: prefixUrl + '/v1/categories/createCategory',
    updateCategories: prefixUrl + '/v1/categories/updateCategories',
    deleteCategory: prefixUrl + '/v1/categories/category/',
    getAllParameters: prefixUrl + '/v1/parameters/getAllParameters',
    readLocation: prefixUrl + '/v1/location/getAll',
    createUserAddress: prefixUrl + '/v1/location/createUserAddress',
    getParameter: prefixUrl + '/v1/parameters/getParameter',
    deleteParameter: prefixUrl + '/v1/parameters/parameter/',
    shoppingCarts: prefixUrl + '/v1/shopping-carts/',
    quotations: prefixUrl + '/v1/authentication/quotations',
    createParameter: prefixUrl + '/v1/parameters/createParameter',
    updateParameters: prefixUrl + '/v1/parameters/updateParameters',
    createCheckout: prefixUrl + '/v1/checkout',
    files: prefixUrl + '/v1/files',
    getAllRequests: prefixUrl + '/v1/letter-credit/getAllUserRequests',
    createRequest : prefixUrl + '/v1/letter-credit/createRequest',
    updateRequest: prefixUrl + '/v1/letter-credit/updateRequest',
    getRequest: prefixUrl + '/v1/letter-credit/getRequest',
    assignToMe: prefixUrl + '/v1/letter-credit/assignToMe',
    createDocument: prefixUrl + '/v1/letter-credit/createDocument',
    deleteDocument: prefixUrl + '/v1/letter-credit/document',
    getAllKairosBanners: prefixUrl + '/v1/banners/getAllKairosBanners',
    //Read secret configs
    getFeatureStatus: prefixUrl + '/v1/features/getFeatureStatus',
    getExternalLinks: prefixUrl + '/v1/external-links/readAll',
    getPaymentScripts: prefixUrl + '/v1/external-links/getPaymentScripts',
    getKairosConfig: prefixUrl + '/v1/kairos-config/readAll',
    getContactDetails: '/api/v1/external-links/getContactDetails',

    createToken: '/api/v1/tokens/createToken',
    updateTokens: '/api/v1/tokens/updateTokens',
    getToken: '/api/v1/tokens/getToken',
    deleteToken: '/api/v1/tokens/token/',
    getAllTokens: '/api/v1/tokens/getAllTokens',
    searchTokens: '/api/v1/tokens/searchTokens',
    getShippingData: prefixUrl + '/v1/products/getShippingData',

};
